/**
 * Two initials for the avatar when there is no photo: first name and last name
 * when a display name has both, otherwise the first two letters of what stands
 * in — the local part of the email, never the domain.
 */
export function initialsFrom(displayName: string | null, email: string | null): string {
  const source = (displayName || email || '').replace(/@.*/, '');
  const parts = source.split(/[.\s_-]+/).filter(Boolean);
  if (parts.length === 0) {
    return '·';
  }
  const first = parts[0][0] ?? '';
  const second = parts.length > 1 ? parts[parts.length - 1][0] : (parts[0][1] ?? '');
  return (first + second).toUpperCase() || '·';
}

/** The message to show for a Firebase password-change error code. */
export function passwordErrorKey(code: string | undefined): string {
  switch (code) {
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'profileMenu.pwdErrorWrong';
    case 'auth/weak-password':
      return 'profileMenu.pwdErrorWeak';
    case 'auth/too-many-requests':
      return 'profileMenu.pwdErrorTooMany';
    default:
      return 'profileMenu.pwdErrorGeneric';
  }
}
